import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'aditya-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css']
})
export class ReportsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
